export const KIERAN_ONEILL: string = 'kieran.oneill@element43.xyz';
